<template>
  <b-overlay
      :show="overlay"
      rounded="sm"
  >
    <div>

      <b-card
          no-body
          class="mb-0"
      >
        <div class="m-2">
          <!-- Table Top -->
          <b-row>
            <b-col
                cols="12"
                md="3"
                class="d-flex align-items-center justify-content-start mt-1"
            >
              <label class="mr-1">شروع تاریخ از : </label>
              <input
                  type="text"
                  id="startPaymentDate"
                  :value="createJalaliDate(fromDate)"
                  class="form-control p-0 form-control-lg mx-auto block w-50 rounded-full text-center bg-gray-100 border-transparent focus:border-gray-500 focus:bg-white focus:ring-0"
              />
              <custom-date-picker
                  v-model="fromDate"
                  format="YYYY-MM-DD"
                  display-format="jYYYY/jMM/jDD"
                  class=""
                  element="startPaymentDate"
                  type="date"
                  color="#5c6bc0"
                  simple
                  class="position-absolute p-0"
              ></custom-date-picker>
            </b-col>

            <b-col
                cols="12"
                md="3"
                class="d-flex align-items-center justify-content-start mt-1"
            >
              <label class="mr-1">تا : </label>
              <input
                  type="text"
                  id="endPaymentDate"
                  :value="createJalaliDate(toDate)"
                  class="form-control p-0 form-control-lg mx-auto block w-50 rounded-full text-center bg-gray-100 border-transparent focus:border-gray-500 focus:bg-white focus:ring-0"
              />
              <custom-date-picker
                  v-model="toDate"
                  format="YYYY-MM-DD"
                  display-format="jYYYY/jMM/jDD"
                  class=""
                  element="endPaymentDate"
                  type="date"
                  color="#5c6bc0"
                  simple
                  class="position-absolute p-0"
              ></custom-date-picker>
            </b-col>

            <b-col
                cols="12"
                md="3"
                class="d-flex align-items-center justify-content-start mt-1"
            >
              <label class="mr-1">بازه درصد از : </label>
              <div class="d-flex align-items-center justify-content-end">
                <b-form-input
                    type="number"
                    v-model="valueFrom"
                    class="d-inline-block mr-1"
                    placeholder=""
                />
              </div>
            </b-col>

            <b-col
                cols="12"
                md="3"
                class="d-flex align-items-center justify-content-start mt-1"
            >
              <label class="mr-1">تا : </label>
              <div class="d-flex align-items-center justify-content-end">
                <b-form-input
                    type="number"
                    v-model="valueTo"
                    class="d-inline-block mr-1"
                    placeholder=""
                />
              </div>
            </b-col>

<!--            <b-col-->
<!--                cols="12"-->
<!--                md="2"-->
<!--                class="d-flex align-items-center justify-content-start mt-1"-->
<!--            >-->
<!--              <b-button-->
<!--                  variant="warning"-->
<!--                  @click="searchWithDate"-->
<!--                  :block="$store.getters['app/currentBreakPoint'] === 'xs'"-->
<!--              >-->
<!--                جستجو با تاریخ-->
<!--              </b-button>-->
<!--            </b-col>-->
          </b-row>
          <b-row>
            <b-col
                cols="12"
                md="2"
                class="d-flex align-items-center justify-content-start mt-1"
            >
              <b-button
                  variant="warning"
                  @click="searchWithDate"
                  :block="$store.getters['app/currentBreakPoint'] === 'xs'"
              >
                جستجو
              </b-button>
            </b-col>
            <b-col
                cols="12"
                md="2"
                class="d-flex align-items-center justify-content-start mb-md-0 mt-1"
            >
              <b-button
                  variant="success"
                  class=""
                  :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                  @click="downloadFile"
              >
                دانلود اکسل لیست
              </b-button>
            </b-col>
          </b-row>
        </div>
      </b-card>

      <!-- Table Container Card -->
      <b-card
          no-body
          class="mb-0"
      >

        <b-table
            ref="refUserListTable"
            class="position-relative"
            :items="coupons"
            responsive
            :fields="myTableColumns"
            primary-key="id"
            show-empty
            bordered
            striped
            empty-text="موردی موجود نیست!"
        >

          <!-- Column: type -->

          <template #cell(type)="data">

            <div class=" d-flex flex-row ">
              <span v-if="data.item.type === 2" class="text-primary">مبلغ</span>
              <span v-else class="text-success">درصد</span>
            </div>

          </template>

          <!-- Column: couponValue -->

          <template #cell(couponValue)="data">

            <div class=" d-flex flex-row ">
              <span v-if="data.item.type === 2" class="text-primary">{{makePrettyPrice(data.item.couponValue)}} تومان</span>
              <span v-else class="text-success">{{data.item.couponValue}}%</span>
            </div>

          </template>

          <!-- Column: startDate -->

          <template #cell(startDate)="data">

            <small class="">
              {{data.item.startDate.slice(11,16)}}
              -
              {{createJalaliDate(data.item.startDate.slice(0,10))}}
            </small>

          </template>

          <!-- Column: endDate -->

          <template #cell(endDate)="data">

            <small class="">
              {{data.item.endDate.slice(11,16)}}
              -
              {{createJalaliDate(data.item.endDate.slice(0,10))}}
            </small>

          </template>

          <!-- Column: execution -->

          <template #cell(execution)="data">

            <div class=" d-flex flex-row ">
              <span v-if="data.item.execution === 1" class="text-primary">عمومی</span>
              <span v-else class="text-success">شخصی</span>
            </div>

          </template>

          <!-- Column: baseQuantity -->

          <template #cell(baseQuantity)="data">

            <div class=" d-flex flex-row ">
              <span v-if="data.item.execution === 2" class="text-success">-</span>
              <span v-else class="text-success">{{data.item.baseQuantity}}</span>
            </div>

          </template>

          <!-- Column: maintainedQuantity -->

          <template #cell(maintainedQuantity)="data">

            <div class=" d-flex flex-row ">
              <span v-if="data.item.execution === 2" class="text-success">-</span>
              <span v-else class="text-success">{{data.item.maintainedQuantity}}</span>
            </div>

          </template>

          <!-- Column: userId -->

          <template #cell(userId)="data">

            <div class=" d-flex flex-row ">
              <span v-if="data.item.execution === 1" class="text-success">-</span>
              <span v-else class="text-success">{{data.item.userId}}</span>
            </div>

          </template>

          <!-- Column: hasUsedByUser -->

          <template #cell(hasUsedByUser)="data">

            <div class=" d-flex flex-row ">
              <span v-if="data.item.hasUsedByUser" class="text-primary">استفاده شده</span>
              <span v-else class="text-danger">استفاده نشده</span>
            </div>

          </template>

          <!-- Column: createDate -->

          <template #cell(createDate)="data">

            <small class="">
              {{data.item.createDate.slice(11,16)}}
              -
              {{createJalaliDate(data.item.createDate.slice(0,10))}}
            </small>

          </template>

          <!-- Column: delete -->

          <template #cell(delete)="data">

            <div class="cursor-pointer d-flex flex-row"
                 v-b-modal.modal-delete
                 @click="showModal(data.item.couponId)"
            >
              <feather-icon icon="TrashIcon" size="20" class="text-danger" />
            </div>

          </template>

          <template #cell(edit)="data">

            <router-link :to="{ name: 'apps-coupon-edit', params: { id: data.item.couponId } }" class="cursor-pointer d-flex flex-row">
              <feather-icon icon="EditIcon" size="20"/>
            </router-link>

          </template>

          <template #cell(used)="data">

            <router-link :to="{ name: 'apps-coupon-used', params: { id: data.item.couponId } }" class="cursor-pointer d-flex flex-row">
              <feather-icon icon="UserIcon" size="20"/>
            </router-link>

          </template>

        </b-table>
        <div class="mx-2 mb-2">
          <b-row>

            <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <!--            <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>-->
            </b-col>
            <!-- Pagination -->
            <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <QueriedPagination v-if="totalCount" v-model="currentPage" :total-counts="totalCount"
                                 :per-page="perPage"></QueriedPagination>

            </b-col>

          </b-row>
        </div>
      </b-card>
    </div>
    <b-modal
        id="modal-delete"
        centered
        ok-title="حذف"
        cancelTitle="انصراف"
        @ok="deleteCoupon(deleteItem)"
    >
      <span>حذف شود؟</span>
    </b-modal>
  </b-overlay>
</template>

<script>
import {BButton, BCard, BCol, BFormInput, BModal, BOverlay, BPagination, BRow, BTable,} from 'bootstrap-vue'
import vSelect from 'vue-select'
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import {CouponDeleteRequest, CouponGetAllRequest} from "@/libs/Api/Coupon";
import Helper from "@/libs/Helper";
import QueriedPagination from "@/views/components/QueriedPagination.vue";
import {saveAs} from 'file-saver';
import {getUserData} from "@/auth/utils";
import axiosIns from "@/libs/axios";

export default {
  name: "CouponList",
  title:"لیست کوپن ها - پنل ادمین رها مزون",
  data(){
    return{
      coupons:null,
      overlay:false,
      totalCount:null,
      addNewCategory:false,
      currentPage:1,
      deleteItem:null,
      perPage:10,
      searchCommand:'',
      perPageOptions:[10, 20, 30 , 40 , 50],
      myTableColumns : [
        { key: 'couponId',label:'شناسه'},
        { key: 'type',label:'نوع'},
        { key: 'couponValue',label:'ارزش'},
        { key: 'startDate',label:'شروع'},
        { key: 'endDate',label:'پایان'},
        { key: 'productId',label:'محصول'},
        { key: 'execution',label:'نوع اجرا'},
        { key: 'baseQuantity',label:'تعداد کل'},
        { key: 'maintainedQuantity',label:'تعداد باقی مانده'},
        { key: 'userId',label:'شناسه شخص'},
        { key: 'code',label:'کد'},
        { key: 'hasUsedByUser',label:'وضعیت'},
        { key: 'createDate',label:'ثبت'},
        { key: 'delete',label:'حذف'},
        { key: 'edit',label:'ویرایش'},
        { key: 'used',label:'مصرف کنندگان'},
      ],
      defaultGetData:{
        pageNumber:1,
        count:10,
        searchCommand:'',
      },
      valueFrom:'',
      valueTo:'',
      fromDate:'',
      toDate:'',
      defaultCreateData:{
        isDeleted:false,
        productCategoryId:0,
        parentId:0,
        name:''
      },
    }
  },
  async created(){
    if (this.$route.query.pageNumber) {
      this.defaultGetData.pageNumber = +this.$route.query.pageNumber
      this.currentPage = +this.$route.query.pageNumber
    }
    await this.getAllCoupons(this.defaultGetData.pageNumber,this.defaultGetData.count,this.valueFrom,this.valueTo,this.fromDate,this.toDate)
  },
  methods:{
    async getAllCoupons(pageNumber,count,valueFrom,valueTo,fromDate,toDate){
      let _this = this;
      _this.overlay =true;
      let  defaultGetData={
        pageNumber:pageNumber,
        count:count,
        valueFrom:valueFrom,
        valueTo:valueTo,
        fromDate:fromDate,
        toDate:toDate,
      }

      let couponGetAllRequest = new CouponGetAllRequest(_this);
      couponGetAllRequest.setParams(defaultGetData);
      await couponGetAllRequest.fetch(function (content){
        _this.overlay = false;
        _this.coupons = content.coupons;
        _this.totalCount = content.couponsCount;
      },function (error){
        _this.overlay = false;
      })
    },
    async deleteCoupon(param){
      let _this = this;
      _this.overlay = true;

      let couponDeleteRequest = new CouponDeleteRequest(_this);
      couponDeleteRequest.setId(param);
      await couponDeleteRequest.fetch(function (content){
        _this.overlay = false;
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات موفق`,
            icon: 'CheckIcon',
            variant: 'success',
            text: `کوپن حذف شد.`,
          },
        })
        window.location.reload();
      },function (error){
        _this.overlay = false;
      })
    },
    searchWithDate(){
      this.getAllCoupons(this.defaultGetData.pageNumber,this.defaultGetData.count,this.valueFrom,this.valueTo,this.fromDate,this.toDate);
    },
    createJalaliDate(param) {
      if (param !== null && param !== '') {
        return new Date(param).toLocaleDateString("fa-IR",);
      }
    },
    makePrettyPrice(param){
      return Helper.prettyPrice(param,0)
    },
    showModal(param){
      let _this = this;
      _this.deleteItem = param
    },
    async downloadFile() {
      let _this = this;
      this.$store.commit('app/TOGGLE_DOWNLOAD')
      let userToken = getUserData().token;

      await axiosIns.post(`/Coupon/GetAllExcel`, {
        count: this.totalCounts,
      }, {
        responseType: 'blob',
      }).then(resp => {
        saveAs(resp.data, 'لیست کوپن ها.xlsx');
      }).catch((error) => {
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: 'عملیات ناموق!',
            icon: 'CheckIcon',
            variant: 'danger',
            text: 'به علت ترافیک بالا سرور لطفا 30 دقیقه دیگر امتحان کنید',
          },
        })
      }).finally(() => {
        this.$store.commit('app/TOGGLE_DOWNLOAD')
      });
    },
  },
  watch:{
    getQuery: function (nv, ov) {
      this.getAllCoupons(this.currentPage, this.defaultGetData.count, this.valueFrom, this.valueTo, this.fromDate, this.toDate);
    },
  },
  computed: {
    getQuery() {
      return this.$route.query
    },
  },
  components:{
    QueriedPagination,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BPagination,
    BOverlay,
    BModal,

    vSelect,
  },
}
</script>

<style scoped>

</style>
